import { queryOptions } from '@tanstack/react-query';

import { apiFileFetch } from '../index';
import { GetFileRes, GetFilesRes } from './types';

export const FILES_QUERY_KEYS = {
  files: 'files',
};

export const _getFile = (id?: string, includeUrl: boolean = false) => {
  return queryOptions({
    enabled: !!id,
    queryKey: [FILES_QUERY_KEYS.files, id, includeUrl],
    queryFn: () =>
      apiFileFetch<GetFileRes>(`/files/${id}`, {
        params: includeUrl ? { include: 'url' } : undefined,
      }),
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

export const _getFiles = (
  ids?: string[],
  params?: {
    include?: 'url';
  },
) => {
  return queryOptions({
    enabled: !!ids && ids.filter((el) => el).length > 0,
    queryKey: [FILES_QUERY_KEYS.files, ids, params?.include],
    queryFn: () =>
      apiFileFetch<GetFilesRes>(`/files/batch`, {
        method: 'POST',
        body: {
          ids,
        },
        params,
      }),
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
